import { Paragraph, Table } from '@digdir/designsystemet-react';
import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";

export function AthleteOverviewTable() {
    const { data } = UseAthleteOverview()
    const { athleteTable } = data
    const handleSelectAthlete = (fisCode: number) => {
        const searchParams = new URLSearchParams(window.location.search);

        searchParams.set("fisCode", fisCode.toString());

        window.location.href = `${window.location.pathname}?${searchParams.toString()}`;
    }

    return (
        <div>
            <Table className="hidden md:table">
                <Table.Head>
                    <Table.Row className="border-b-2 border-neutralNsf">
                        <Table.HeaderCell>Nr.</Table.HeaderCell>
                        <Table.HeaderCell>Navn</Table.HeaderCell>
                        <Table.HeaderCell>Idretsslag</Table.HeaderCell>
                        <Table.HeaderCell>Født</Table.HeaderCell>
                        <Table.HeaderCell>Poeng</Table.HeaderCell>
                    </Table.Row>
                </Table.Head>
                <Table.Body>
                    {athleteTable.athletes.map((athlete) => (
                        <Table.Row onClick={() => handleSelectAthlete(athlete.fisCode)} key={athlete.fisCode}
                            className="border-b border-neutralNsf">
                            <Table.Cell>{athlete.ranking}</Table.Cell>
                            <Table.Cell>{athlete.fullName}</Table.Cell>
                            <Table.Cell>{athlete.club}</Table.Cell>
                            <Table.Cell>{athlete.birthYear}</Table.Cell>
                            <Table.Cell>{athlete.points}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <Table className="table md:hidden">
                <Table.Head>
                    <Table.Row className="border-b-2 border-neutralNsf">
                        <Table.HeaderCell>Nr.</Table.HeaderCell>
                        <Table.HeaderCell>Navn (født), idrettslag</Table.HeaderCell>
                        <Table.HeaderCell>Poeng</Table.HeaderCell>
                    </Table.Row>
                </Table.Head>
                <Table.Body>
                    {athleteTable.athletes.map((athlete) => (
                        <Table.Row onClick={() => handleSelectAthlete(athlete.fisCode)} key={athlete.fisCode}
                            className="border-b border-neutralNsf">
                            <Table.Cell>{athlete.ranking}</Table.Cell>
                            <Table.Cell>
                                <div className="flex flex-col gap-1">
                                    <Paragraph className="!mb-0">
                                        {athlete.fullName} ({athlete.birthYear})
                                    </Paragraph>
                                    <Paragraph className="text-neutral-text-subtle !mb-0">
                                        {athlete.club}
                                    </Paragraph>
                                </div>
                            </Table.Cell>
                            <Table.Cell>{athlete.points}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    )
}